import { Plus } from 'lucide-react'
import { useState } from 'react'
import { toast } from 'sonner'
import { Badge } from '@/components/ui/badge'
import { Button } from '@/components/ui/button'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { Input } from '@/components/ui/input'
import { Skeleton } from '@/components/ui/skeleton'
import { useCreateTag, useTags } from '@/hooks/use-tags'

export default function TagsPage() {
  const { data, isLoading } = useTags()
  const createTag = useCreateTag()
  const [newTagName, setNewTagName] = useState('')

  const tags = (data as any) ?? []

  const handleCreate = async () => {
    if (!newTagName.trim()) return
    try {
      await createTag.mutateAsync({ name: newTagName.trim() })
      setNewTagName('')
      toast.success('タグを作成しました')
    } catch {
      toast.error('タグの作成に失敗しました')
    }
  }

  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-bold">タグ管理</h1>

      <Card>
        <CardHeader>
          <CardTitle>新しいタグを追加</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="flex gap-2">
            <Input
              placeholder="タグ名..."
              value={newTagName}
              onChange={(e) => setNewTagName(e.target.value)}
              onKeyDown={(e) => e.key === 'Enter' && handleCreate()}
            />
            <Button onClick={handleCreate} disabled={createTag.isPending}>
              <Plus className="mr-2 h-4 w-4" />
              追加
            </Button>
          </div>
        </CardContent>
      </Card>

      <Card>
        <CardHeader>
          <CardTitle>タグ一覧</CardTitle>
        </CardHeader>
        <CardContent>
          {isLoading ? (
            <Skeleton className="h-20" />
          ) : tags.length === 0 ? (
            <p className="text-muted-foreground">タグがありません。</p>
          ) : (
            <div className="flex flex-wrap gap-2">
              {tags.map((tag: any) => (
                <Badge key={tag.id} variant="secondary" className="text-sm">
                  {tag.name}
                </Badge>
              ))}
            </div>
          )}
        </CardContent>
      </Card>
    </div>
  )
}
